import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'
import {
  getABTestConfig,
  longevityCompassABTestRouteConfig,
} from '@config/abTestConfig'

/**
 * Longevity Compass onboarding outlet
 * Uses shared ABTestSectionOutlet with app-specific configuration
 */
export default function LongevityCompassOnboardingOutlet() {
  return (
    <ABTestSectionOutlet
      basePath="/onboarding"
      routeConfig={longevityCompassABTestRouteConfig}
      getABTestConfig={getABTestConfig}
      variantPathPrefixes={{ v1: 'v1' }}
      validVariants={['baseline', 'v1']}
    />
  )
}
